import { createAction, props } from '@ngrx/store';
export const setHypotheticalId = createAction('[Hypotheticals] Set Hypothetical Id', props());
